import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AppConstants} from '../../shared/constants/app-constant';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from '../../shared/services/alert.service';
import {StockistService} from '../../shared/services/stockist.service';
import {WithdrawRequestService} from '../../shared/services/withdraw-request.service';

@Component({
    selector: 'app-withdraw-activation-amount',
    templateUrl: './withdraw-activation-amount.component.html',
    styleUrls: ['./withdraw-activation-amount.component.scss']
})
export class WithdrawActivationAmountComponent implements OnInit {
    showSearch = false;
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    addWithdrawRequestForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    modalType: any;
    withDrawRequests: any = [];
    userData: any;
    withdrawRequestStatuses: any = AppConstants.WITHDRAW_REQUEST_STATUSES;

    constructor(private router: Router,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private alertService: AlertService,
                private withDrawRequestService: WithdrawRequestService,
                private stockistService: StockistService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'amount': [''],
            'status': [''],
        });
        this.addWithdrawRequestForm = this.fb.group({
            'amount': ['', Validators.required]
        });
        this.getUserDetail();
    }

    getUserDetail() {
        this.stockistService.selfDetail().subscribe(data => {
            if (data) {
                this.userData = data;
                this.get();
            }
        });
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.withDrawRequests = [];
        this.withDrawRequestService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.withDrawRequests = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.withDrawRequests = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    search() {
        const params = {
            'amount': (this.searchForm.value && this.searchForm.value.amount) ? this.searchForm.value.amount : '',
            'status': (this.searchForm.value && this.searchForm.value.status) ? this.searchForm.value.status : '',
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            'amount': (this.searchForm && this.searchForm.value && this.searchForm.value.amount) ? this.searchForm.value.amount : '',
            'status': (this.searchForm && this.searchForm.value && this.searchForm.value.status) ? this.searchForm.value.status : '',
        };
        this.get(params);
    }

    openWithdrawRequestOpenModal(content) {
        this.modalType = 'ADD_WITHDRAW_REQUEST';
        this.modalService.open(content, {'size': 'lg'});
    }

    submit() {
        this.submitted = true;
        if (!this.addWithdrawRequestForm.valid) {
            this.submitted = false;
            return;
        }
        if (parseFloat(this.userData['activation_amount']) > parseFloat(this.addWithdrawRequestForm.value.amount)) {
            if (this.submitted) {
                const params = {
                    'amount': (this.addWithdrawRequestForm.value && this.addWithdrawRequestForm.value.amount) ? this.addWithdrawRequestForm.value.amount : ''
                };
                this.submitting = true;
                this.withDrawRequestService.create(params).subscribe(data => {
                    this.submitting = false;
                    this.submitted = false;
                    this.addWithdrawRequestForm.reset();
                    this.addWithdrawRequestForm.patchValue({
                        'amount': ''
                    });
                    this.modalService.dismissAll('');
                    this.get();
                }, error => {
                    this.submitting = false;
                    this.submitted = false;
                });
            }
        } else {
            this.alertService.showErrors('Requested amount can\'t be greater than activation amount');
            this.submitted = false;
        }
    }
}
